import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import http from "../common/http-commons";

export interface IEmployeePermissionData {
  lastPeriodProcessed?: string;
  salaryProfileExist?: boolean;
  calculatePayroll?: boolean;
}
export const PermissionsService = {
  getEmployeePermissionData: async (
    clientId: string,
    payrollScheduleId: string,
    navigateToLogout: (path: string) => void,
    employeeId?: string | null,
  ): Promise<IServerError | IResponse | IEmployeePermissionData | null> => {
    if (!payrollScheduleId) return null;
    try {
      const response: AxiosResponse<IEmployeePermissionData> =
        await http.get<IEmployeePermissionData>(
          "/v1/payroll-schedule/permissions/for-employee/for-payroll/from-shedule/?client_id=" +
            clientId +
            "&payroll_shedule_id=" +
            payrollScheduleId +
            (employeeId ? "&employee_id=" + employeeId : ""),
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getSalaryPeofilePermissionData: async (
    clientId: string,
    navigateToLogout: (path: string) => void,
    employeeId: string | null,
    payrollScheduleId?: string | null,
  ): Promise<IServerError | IResponse | IEmployeePermissionData | null> => {
    if (!employeeId) return null;
    try {
      const response: AxiosResponse<IEmployeePermissionData> =
        await http.get<IEmployeePermissionData>(
          "/v1/payroll-schedule/permissions/for-employee/for-payroll/from-shedule/?client_id=" +
            clientId +
            (payrollScheduleId
              ? "&payroll_shedule_id=" + payrollScheduleId
              : "") +
            "&employee_id=" +
            employeeId,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
};
